/**
 * Normalize list API payloads that may be a bare array, a `{ items }` page,
 * or a `{ data }` / `{ success, data }` envelope.
 */
export function asArray<T = unknown>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (!value || typeof value !== 'object') return [];

  const obj = value as Record<string, unknown>;
  if (Array.isArray(obj.items)) return obj.items as T[];
  if (Array.isArray(obj.data)) return obj.data as T[];
  if (
    obj.success === true &&
    obj.data &&
    typeof obj.data === 'object' &&
    Array.isArray((obj.data as Record<string, unknown>).items)
  ) {
    return (obj.data as { items: T[] }).items;
  }
  return [];
}
